import React, { ElementType, memo } from 'react'
import { datetimeFormatter, IDatetimeFormatterArgs } from './utils/datetimeFormatter'

export interface IFormattedDatetimeProps extends IDatetimeFormatterArgs {
  /**
   * Pass a component in which the datetime value will be rendered as a child.
   * @default 'span'
   */
  as?: ElementType
  className?: string
  dataTest?: string
}

export const FormattedDateTime = memo<IFormattedDatetimeProps>(
  ({
    abbreviated,
    as: Component = 'span',
    className,
    dataTest,
    datetime,
    displayTimezone,
    format,
    inSentence,
    showTimezone,
    timeShort,
  }) => (
    <Component className={className} data-test={dataTest}>
      {datetimeFormatter({
        datetime,
        displayTimezone,
        format,
        inSentence,
        showTimezone,
        abbreviated,
        timeShort,
      })}
    </Component>
  )
)

export default FormattedDateTime
